import type React from 'react';

import { Box } from 'ui/box';

import Icons from 'assets/icons';

const COLOR_TRANSITION_SX = {
  transitionProperty:
    'color, background-color, border-color, text-decoration-color, fill, stroke',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  transitionDuration: '100ms',
};

interface FreeformOptionProps {
  value: string;
  isActive: boolean;
  onChange: (value: string) => void;
}

const FreeformOption = ({
  value,
  isActive,
  onChange,
}: FreeformOptionProps): React.JSX.Element => (
  <Box
    component="label"
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        width: '100%',
        px: 1.75,
        py: 1.25,
        borderRadius: '0.375rem',
        cursor: 'text',
        ...COLOR_TRANSITION_SX,
      },
      isActive && {
        bgcolor: 'tokens.navy.50',
        borderWidth: '2px',
        borderColor: 'tokens.navy.600',
      },
      !isActive && {
        bgcolor: 'common.white',
        borderWidth: '1px',
        borderColor: 'tokens.gray.200',
        '&:focus-within': { borderColor: 'tokens.navy.700' },
        '&:hover': {
          bgcolor: 'tokens.navy.50',
          borderColor: 'tokens.navy.300',
        },
      },
    ]}
  >
    <span aria-hidden="true" className="text-gray-400 flex flex-shrink-0">
      <Icons.EditPencil customClass="size-3.5" />
    </span>
    <input
      type="text"
      aria-label="Something else — type your own answer"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Something else — type your own answer"
      className="flex-1 border-none bg-transparent text-sm text-gray-700 outline-none placeholder:text-gray-400 placeholder:italic"
    />
  </Box>
);

export default FreeformOption;
